
import { Box, makeStyles } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Redirect } from 'react-router-dom';
import adminRoutesConstant from '../../../../constants/adminRoutesConstant';
import masterDataFormConstant from '../../../../constants/formConstants/masterDataFormConstants';
import { createBanner, getBannerById, updateBanner } from '../../../../services/masterDataService';
import Button from '../../../commons/Button/Button';
import GenerateFormHook from '../../../commons/GenerateFormHook';
import PaperWrapper from '../../../commons/Paper/PaperWrapper';
import Text from '../../../commons/Text';

const useStyles = makeStyles(theme => ({
  preview: {
    width: '25rem',
    height: 'auto',
    display: 'block'
  }
}))

const BannerForm = ({
  match,
  readOnly = false,
  setBannerIsActive
}) => {
  const classes = useStyles()
  const { handleSubmit, reset } = useFormContext()
  const { enqueueSnackbar } = useSnackbar();

  const { id } = match && match.params ? match.params : {};

  const [redirect, setRedirect] = React.useState(false);
  const [btnIsLoading, setBtnIsLoading] = React.useState(false)
  const [dataById, setDataById] = React.useState({});
  const [formConst, setFormConst] = React.useState(masterDataFormConstant.forBanners(readOnly))

  const redirectToDetailsPage = () => {
    setRedirect(true);
  }

  const handleFormSubmit = (data) => {
    data.priority = (data.priority.length === 0) ? 0 : data.priority

    setBtnIsLoading(true);
    if (id) {
      updateBanner({
        ...dataById,
        ...data,
      }, id).then((response) => {
        redirectToDetailsPage()
        setBtnIsLoading(false);
      })
    } else {
      createBanner(data).then(response => {
        redirectToDetailsPage()
        setBtnIsLoading(false);
      })
    }
  }

  const fetchDataById = (data) => {
    getBannerById(data).then((response) => {
      if (response) {
        reset({
          ...response[0]
        })
        setDataById(response[0])
        setBannerIsActive(response[0].is_active)
      }
    });
  }

  React.useEffect(() => {
    if (id) {
      fetchDataById(id)
    }
  }, [id])

  return (

    <PaperWrapper>
      {redirect && <Redirect to={adminRoutesConstant.adminUrls.AllBannerScreen.url()} />}
      <GenerateFormHook formConstant={formConst} />
      <Box mt={2} mb={4}>
        <Text>Required aspect ratios for image urls:-</Text>
        <Text>Web = 887 : 213</Text>
        <Text>Mobile = 16 : 9</Text>
      </Box>
      {
        dataById.id && (
          <Box my={4}>
            <Text fontSize={18} fontWeight={600} margin='0 0 1rem 0'>Banner Previews:-</Text>
            <img className={classes.preview} src={dataById.web_banner} alt='web banner' />
            <Text margin='0.5rem 0 1rem 0'>Web Banner</Text>
            <img className={classes.preview} src={dataById.mobile_banner} alt='mobile banner' />
            <Text margin='0.5rem 0 1rem 0'>Mobile Banner</Text>
          </Box>
        )
      }
      {
        !readOnly && <Button isLoading={btnIsLoading} onClick={handleSubmit(handleFormSubmit)} variant='contained' color='primary'>{id ? "Save Changes" : "Add"}</Button>
      }
    </PaperWrapper>
  )
}

export default BannerForm
